﻿import template from 'lodash.template';

import findAncestorWithAttr from '../Utils/findAncestorWithAttr';
import validateInput from '../Utils/validateInput';
import {isValidDate, isPositiveInteger, validSwedishZipCode} from '../Forms/Validation/rules';

import LfDataService from '../Services/LfDataService';
import LfWebService from '../Services/LfWebService';

export default class CatInsuranceQuoteHandler {
    constructor() {
        this.lfWebService = new LfWebService(); 
        this.lfDataService = new LfDataService();
        this.loaderMinShowTime = 1000; 

        this.resultTemplateId = 'cat-insurance-quote-result__template';
        this.resultTemplate = null; 
        this.errorTemplateId = 'cat-insurance-quote-error__template';
        this.errorTemplate = null; 

        this.resultContainerSl = '.cat-insurance-quote-block__result';
        this.buttonSl = '.cat-insurance-quote-form__button';

        // inputs
        this.animalBreedSl = '.cat-insurance-quote-form__input__breed';
        this.animalBirthDateSl = '.cat-insurance-quote-form__input__animal-birthdate';
        this.hasBeenPreviouslyInsuredSl = '.cat-insurance-quote-form__input__not_prev_insured:checked';
        this.animalGenderSl = 'input[name="animalGender"]:checked';
        this.zipCodeSl = '.cat-insurance-quote-form__input__zipcode';
        this.includeLifeInsuranceQuoteSl = '.cat-insurance-quote-form__input__include-life-insurance-quote:checked';
        this.lifeValueSl = '.cat-insurance-quote-form__input__life-insurance-value';

        this.validationRules = [
            { sl: this.animalBreedSl, rule: val => val ? undefined : false }, // not empty
            { sl: this.hasBeenPreviouslyInsuredSl, rule: val => undefined},
            { sl: this.animalGenderSl, rule: val => undefined }, // always valid
            { sl: this.zipCodeSl, rule: validSwedishZipCode },
            { sl: this.includeLifeInsuranceQuoteSl, rule: val => undefined }, // always valid
            { sl: this.animalBirthDateSl, rule: isValidDate },
            { sl: this.lifeValueSl, rule: val => { // apply isPosInt rule if includeLifeInsuranceQuote is checked
                let reqEl = document.querySelector(`${this.includeLifeInsuranceQuoteSl}:checked`);
                return reqEl && reqEl.value ? isPositiveInteger(val) : undefined;
            }}
        ];

        // sl's
        this.loaderSl = `.cat-insurance-quote-block .loader`;
        this.loaderActiveCl = 'loader--active';

        this.accordionBodyAttr = 'data-lf-accordion-body';

        this.loadStartTimeStamp = null; 
        this.initialize(); 
    }

    initialize() {
        let templateEl = document.getElementById(this.resultTemplateId);
        let errorTemplateEl = document.getElementById(this.errorTemplateId); 
        if (!templateEl || !errorTemplateEl) { // shouldn't init
            return; 
        }

        this.fetchCatBreeds(); 

        this.resultTemplate = template(templateEl.innerHTML);
        this.errorTemplate = template(errorTemplateEl.innerHTML);
        this.resultContainer = document.querySelector(this.resultContainerSl);

        this.setupEventListeners(); 
    }

    fetchCatBreeds() {
        let selectEl = document.querySelector(this.animalBreedSl);

        this.lfDataService.animalBreeds('cat')
            .then(data =>
                data.breeds.cat.forEach(breed =>
                    selectEl.innerHTML += `<option value="${breed.id}">${breed.name}</option>`
                )
            );
    }

    showLoader = () => {
        let loaderEl = document.querySelector(this.loaderSl);
        loaderEl.classList.add(this.loaderActiveCl);
        this.loadStartTimeStamp = Date.now();         
    }

    waitForLoader = (data) => {
        return new Promise(resolve => { 
            setTimeout(() => {
                let loaderEl = document.querySelector(this.loaderSl);
                loaderEl.classList.remove(this.loaderActiveCl);
                
                resolve(data);
            }, this.loaderMinShowTime - (Date.now() - this.loadStartTimeStamp));
        });        
    }

    getFormValues() {
        return this.validationRules.reduce((values, rule) => {
            let el = document.querySelector(rule.sl);
            if (el && el.value != '') {
                values[el.name] = el.value;
            }
            return values; 
        }, {});
    }

    inputsValid = (inputs) => {
        let allValid = true;
    
        inputs.map(input => {
            let inputEl = document.querySelector(input.sl); 
            if (inputEl && !validateInput(val => typeof input.rule(val) === 'undefined', inputEl)) {
                allValid = false; 
            }
        });

        return allValid; 
    }

    setupEventListeners = () => {
        let formEls = document.querySelectorAll(this.buttonSl);

        formEls.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();

                if (!this.inputsValid(this.validationRules)) {
                    return;
                }

                this.resultContainer.innerHTML = '';
                this.showLoader();

                let formValues = this.getFormValues();
   
                this.lfDataService.getAnimalInsuranceQuotes(
                    'cat', formValues.animalBreedId, formValues.animalBirthDate, formValues.animalGender,
                    typeof formValues.hasBeenPreviouslyInsured !== 'undefined' ? formValues.hasBeenPreviouslyInsured : false,
                    formValues.zipCode, formValues.includeLifeInsuranceQuote, formValues.lifeInsuranceValue
                )
                .then(result => this.waitForLoader(result))
                .then(result => {
                    const insuranceGroups = formValues.includeLifeInsuranceQuote
                        ? ['cat', 'cat-life']
                        : 'cat';

                    const preSelection = formValues.includeLifeInsuranceQuote
                        ? ['{insuranceName}', 'cat-life']
                        : '{insuranceName}';

                    let purchaseBaseUrl =
                        this.lfWebService.insurancePurchaseUrl(insuranceGroups, preSelection, null, formValues);

                    let resultHtml = this.resultTemplate({
                        quotes: result,
                        purchaseBaseUrl
                    });

                    let accordionBody = findAncestorWithAttr(this.resultContainer, this.accordionBodyAttr);
                    this.resultContainer.innerHTML = resultHtml;
                    accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
                })
                .catch(error => 
                    this.waitForLoader()
                        .then(() => this.resultContainer.innerHTML = this.errorTemplate())
                );
            });
        });
    }
}